import { useEffect, useRef, useState } from 'react';
import { eventBus } from '@/events/eventBus';

/**
 * Flash-highlight hook (Prompt F foundation, Prompt G trigger surface). Returns
 * `true` for a short window after any of the given eventBus events fires, so a
 * chart or tile can visibly flash when the store changes underneath it - the
 * "trigger fires visibly move an element" behaviour.
 *
 * Wired now to the live money events (deposit paid, session checked out); Prompt
 * G's triggers publish onto the same bus, so this lights up for those too.
 */
export const FLASH_MS = 1200;

export function useFlashHighlight(eventTypes: readonly string[]): boolean {
  const [flashing, setFlashing] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  // Keep the subscription effect stable across renders even if the caller passes
  // a fresh array literal each time.
  const key = eventTypes.join('|');

  useEffect(() => {
    const types = key ? key.split('|') : [];
    const trigger = () => {
      setFlashing(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setFlashing(false), FLASH_MS);
    };
    const unsubscribers = types.map((t) => eventBus.subscribe(t, trigger));
    return () => {
      unsubscribers.forEach((u) => u());
      if (timer.current) clearTimeout(timer.current);
    };
  }, [key]);

  return flashing;
}
